<div class="header">
  <div class="container">
    <a href="javascript:void(0);" class="logo"><img src="../assets/img/vivotek-logo-n-w.png" alt="" style="width: 120px;" /></a>
    <h1 class="title">Register for Free Re-Search Object Metadata License for VIVOTEK Milestone Plug-in</h1>
  </div>
</div>
<div class="container-wrap">
  <div class="container">
    <div class="alert alert-warning alert-dismissible fade" [ngClass]="{ show: hasError }" role="alert">
      {{ errorMessage }}
      <button type="button" class="close" data-dismiss="alert" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="row">
      <!-- (ngSubmit)="uploadFile()" -->
      <div class="col-lg-12 mt-lg-0 mt-5">
        <div class="card card-csv">
          <div class="card-header">
            Register for Free Re-Search Metadata License [Limited-Time Event]
          </div>
          <div class="card-body">
            <form [formGroup]="frmMultiLicense">
              <div class="form-group row">
                <div class="col-md-12" style="text-align: center;">
                  This registration system is exclusively for use with VIVOTEK Milestone plug-in.<br/>
                  The application period is in year 2025.(Beta Test since 2024/11)<br/>
                  Licenses applied for within this period will have full functionality without any usage limitations.<br/>
                </div>
                <div class="col-md-12" style="text-align: center;">
                  <label>
                    <input type="checkbox" formControlName="terms"/> I Agree
                  </label>
                </div>
                <div class="col-md-12" style="text-align: center;">
                  <label>
                    <span *ngIf="!frmMulti['terms'].value" style="color:#dc3545">
                      Agreement is required
                    </span>
                  </label>
                </div>
              </div>
              <!-- <div class="form-group row">
                <div class="col-md-12">
                  <label>
                    <input type="checkbox" formControlName="terms" /> I Agree
                  </label>
                  <div *ngIf="!frmMulti['terms'].value">
                    Agreement is required
                  </div>
                  <div *ngIf="frmMulti['company'].errors" class="invalid-feedback">
                    <div *ngIf="frmMulti['company'].errors.required">
                      Company Name is required
                    </div>
                  </div>
                </div>
              </div>-->
              <div class="form-group row">
                <label for="company" class="col-md-4 col-form-label">Company Name</label>
                <div class="col-md-8">
                  <input type="text" class="form-control" id="company_free"
                    [ngClass]="{ 'is-invalid': frmMulti.company.invalid }" placeholder="Company Name" formControlName="company" maxlength="50"/>
                  <div *ngIf="frmMulti['company'].errors" class="invalid-feedback">
                    <div *ngIf="frmMulti['company'].errors.required">
                      Company Name is required
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group row">
                <label for="contact" class="col-md-4 col-form-label">Contact Person</label>
                <div class="col-md-8">
                  <input type="text" class="form-control" id="contact_free"
                    [ngClass]="{ 'is-invalid': frmMulti.contact.invalid}" placeholder="Contact Person" formControlName="contact" maxlength="50"/>
                  <div *ngIf="frmMulti['contact'].errors" class="invalid-feedback">
                    <div *ngIf="frmMulti['contact'].errors.required">
                      Contact Person is required
                    </div>
                  </div>
                </div>
              </div>
              <!-- <div class="form-group row">
                <label for="contact" class="col-md-4 col-form-label">Contact Persion Phone Number</label>
                <div class="col-md-8">
                  <input type="text" class="form-control" id="contact_free"
                    [ngClass]="{ 'is-invalid': frmMulti.contactPersionPhone.invalid }" placeholder="Contact Persion Phone Number" formControlName="contactPersionPhone" maxlength="50"/>
                  <div *ngIf="frmMulti['contactPersionPhone'].errors" class="invalid-feedback">
                    <div *ngIf="frmMulti['contactPersionPhone'].errors.required">
                      Contact Persion Phone Number is required
                    </div>
                    <div *ngIf="frmMulti['contactPersionPhone'].errors.pattern">
                      Contact Persion Phone format invalid
                    </div>
                  </div>
                </div>
              </div> -->
              <div class="form-group row">
                <label for="email" class="col-md-4 col-form-label">Email</label>
                <div class="col-md-8">
                  <input type="text" class="form-control" id="email_multiple"
                    [ngClass]="{ 'is-invalid': frmMulti.email.invalid}" placeholder="Email" formControlName="email" />
                  <div *ngIf="frmMulti['email'].errors" class="invalid-feedback">
                    <div *ngIf="frmMulti['email'].errors.required">
                      Email is required
                    </div>
                  </div>
                  <div *ngIf="frmMulti['email'].errors" class="invalid-feedback">
                    <div *ngIf="frmMulti['email'].errors.email">
                      Email format invalid
                    </div>
                  </div>
                  <div *ngIf="frmMulti['email'].errors" class="invalid-feedback">
                    <div *ngIf="frmMulti['email'].errors.pattern">
                      Emails from @vivotek.com are not allowed.
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group row">
                <label for="country" class="col-md-4 col-form-label">Country</label>
                <div class="col-md-8">
                  <input type="text" class="form-control" id="country_single"
                    [ngClass]="{ 'is-invalid': frmMulti.country.invalid}" placeholder="Country" formControlName="country" />
                  <div *ngIf="frmMulti['country'].errors" class="invalid-feedback">
                    <div *ngIf="frmMulti['country'].errors.required">
                      Country is required
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group row">
                <label for="applicationType" class="col-md-4 col-form-label">Application Type</label>
                <div class="col-md-8">
                  <ng-select [items]="applicationTypes" bindLabel="text" bindValue="codeId" formControlName="applicationType"
                    [clearable]="false" [ngClass]="{ 'is-invalid': frmMulti.applicationType.invalid }">
                  </ng-select>
                  <div *ngIf="frmMulti['applicationType'].errors" class="invalid-feedback">
                    <div *ngIf="frmMulti['applicationType'].errors.required">
                      Application Types is required
                    </div>
                  </div>
                </div>
              </div><div class="form-group row">
                <label for="VMSType" class="col-md-4 col-form-label">VMS Type</label>
                <div class="col-md-8">
                  <ng-select [items]="vmsTypes" bindLabel="text" bindValue="codeId" formControlName="vmsType"
                    [clearable]="false" [ngClass]="{ 'is-invalid': frmMulti.vmsType.invalid }" (click)="onChange($event)">
                  </ng-select>
                  <div *ngIf="frmMulti['vmsType'].errors" class="invalid-feedback">
                    <div *ngIf="frmMulti['vmsType'].errors.required">
                      VMS Types is required
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group row" *ngIf="false">
                <label for="country" class="col-md-4 col-form-label">VMS Server Code/ID</label>
                <div class="col-md-8">
                  <input type="text" class="form-control" id="country_single"
                    [ngClass]="{ 'is-invalid': frmMulti.code.invalid}" placeholder="Code/Id" formControlName="code"  />
                  <div *ngIf="frmMulti['code'].errors" class="invalid-feedback">
                    <div *ngIf="frmMulti['code'].errors.invalid">
                      VMS Server Code/ID is required
                    </div>
                    <div *ngIf="frmMulti['code'].errors.pattern">
                      VMS Server Code/ID format invalid
                    </div>
                    <div *ngIf="frmMulti['code'].hasError('maxlength') || frmMulti['code'].hasError('minlength')">
                      VMS Server Code/ID minlength 10 maxlength 30
                    </div>
                  </div>
                </div>
              </div>
              <div  class="form-group row" *ngIf="generateVisible">
                <label for="Upload" class="col-md-4 col-form-label">Upload</label>
                <div class="col-md-4">
                  <label>
                    <input type="radio" formControlName="option" value="single" name="option" checked> Single
                  </label>
                </div>
                  <div class="col-md-4">
                  <label>
                    <input type="radio" formControlName="option" value="mul" name="option"> Multiple
                  </label>
                </div>
              </div>
              <div class="form-group row" *ngIf="!codeVisible">
                <label for="Memo" class="col-md-4"></label>
                <div class="col-md-8">
                  <label for="Memo">Due to the selected VMS not meeting the eligibility criteria for application,
                    if you have specific project needs, please fill out the project information, and our team will contact you.
                  </label>
                </div>
              </div>
              <div class="form-group row" *ngIf="!codeVisible">
                <label for="description" class="col-md-4"></label>
                <div class="col-md-8">
                  <textarea id="description" class="form-control"
                  [ngClass]="{ 'is-invalid': frmMulti.description.invalid}" formControlName="description" rows="3"></textarea>
                  <!-- <div *ngIf="frmMulti['description'].errors" class="invalid-feedback">
                    <div *ngIf="frmMulti['description'].errors.required">
                      description is required
                    </div>
                  </div> -->
                </div>
              </div>
              <div class="form-group row" *ngIf="!codeVisible">
                <label for="description" class="col-md-4"></label>
                <div class="col-md-8" *ngIf="frmMulti['description'].errors">
                  <div *ngIf="frmMulti['description'].errors.required" style="color:#dc3545">
                    Description is required
                  </div>
                  <div *ngIf="frmMulti['description'].hasError('maxlength') || frmMulti['description'].hasError('minlength')" style="color:red">
                    Description minlength 80 maxlength 300
                  </div>
                </div>
              </div>
              <div class="form-group row" *ngIf="TextboxVisible" >
                <label for="licenseType" class="col-md-4 col-form-label">License Type</label>
                <div class="col-md-8">
                  <ng-select [items]="licenseTypes" bindLabel="text" bindValue="codeId" formControlName="licenseType"
                    [searchable]="false" [clearable]="false" [ngClass]="{ 'is-invalid': frmMulti.licenseType.errors }">
                  </ng-select>
                  <div *ngIf="frmMulti['licenseType'].errors" class="invalid-feedback">
                    <div *ngIf="frmMulti['licenseType'].errors.required">
                      License Type is required
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group row" *ngIf="TextboxVisible">
                <label for="modelName" class="col-md-4 col-form-label">Model Name</label>
                <div class="col-md-8">
                  <!-- <input
                    type="text"
                    class="form-control"
                    id="modelName"
                    [ngClass]="{ 'is-invalid': frmSingle.modelName.errors }"
                    placeholder="Model Name"
                    formControlName="modelName"
                  /> -->
                  <ng-select [items]="modelNameTypes" bindLabel="text" bindValue="id" formControlName="modelName"
                    [clearable]="false" [ngClass]="{ 'is-invalid': frmMulti.modelName.errors }">
                  </ng-select>
                  <div *ngIf="frmSingle['modelName'].errors" class="invalid-feedback">
                    <div *ngIf="frmSingle['modelName'].errors.required">
                      Model Name is required
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group row" *ngIf="TextboxVisible">
                <label for="macAddress" class="col-md-4 col-form-label">Mac Address</label>
                <div class="col-md-8">
                  <input type="text" class="form-control" id="macAddress"
                    [ngClass]="{ 'is-invalid': frmMulti.macAddress.errors }" placeholder="Mac Address"
                    formControlName="macAddress" style="text-transform: uppercase;" />
                  <div *ngIf="frmMulti['macAddress'].errors" class="invalid-feedback">
                    <div *ngIf="frmMulti['macAddress'].errors.required">
                      MAC Address is required
                    </div>
                    <div *ngIf="frmMulti['macAddress'].errors.pattern">
                      The pattern of MAC Address is not valid
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group row" *ngIf="fileuploadVisible">
                <label for="csvFile" class="col-md-4 col-form-label">Excel File</label>
                <div class="col-md-8">
                  <!-- {{frmMulti['licenseFile'].value}}
                  {{frmMulti['licenseFile'].value === null}} -->
                  <input #licenseFileElem formControlName="licenseFile"
                    [ngClass]="{ 'is-invalid': frmMulti['licenseFile'].value === null}" type="file" (change)="fileChanged($event)"
                    class="form-control-file" accept=".xlsx" />
                  <!-- <div *ngIf="frmMulti['licenseFile'].value === null" class="invalid-feedback">
                    <div *ngIf="frmMulti['licenseFile'].value === null"> -->
                  <div *ngIf="frmMulti['licenseFile'].errors" class="invalid-feedback">
                    <div *ngIf="frmMulti['licenseFile'].errors.required">
                      File is required
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group row" *ngIf="fileuploadVisible">
              <label for="csvFile" class="col-md-4 col-form-label">Template File</label>
              <div class="col-md-8">
              <a *ngIf="fileuploadVisible" [href]="baseUrl + '/Generate/DownloadVOM'" class="mb-4 d-inline-block link-csv" target="_blank">Sample
                Excel</a>
              </div></div>
              <!-- {{frmMultiLicense.valid}}
              {{frmMulti['licenseFile'].value !== null}}
              {{!(frmMultiLicense.valid && frmMulti['licenseFile'].value !== null)}} -->
            <button [disabled]="ApplyDisable()" type="submit" class="btn btn-primary btn-csv w-100"
              [swal]="confirmSwal" (click)="handleConfirm('multi')">
              <div *ngIf="!generateVisible">Submission</div><div *ngIf="generateVisible">Get Download Link</div>
            </button>
            </form>
          </div>
        </div>
      </div>
    </div>
    <div class="mt-5 text-center">
      <p>
        If you have any question, please contact
        <a href="mailto: {{adminContact}}">{{adminContact}}</a>
      </p>
    </div>
  </div>
</div>
<ngx-spinner></ngx-spinner>
<swal #confirmSwal title="Captcha" [showConfirmButton]="false" [showCloseButton]="true" [showCancelButton]="true"
  (beforeOpen)="beforeOpen($event)">
  <form *swalPartial [formGroup]="frmCaptcha" (ngSubmit)="submit()">
    <div class="form-group row mt-3">
      <div class="col-md-2">
        <a href="javascript:void(0);" (click)="beforeOpen()">
          <img *ngIf="captcha?.image" class="img" [src]="captcha?.image" />
        </a>
      </div>
      <div class="col-md-6">
        <input class="form-control" formControlName="image" />
      </div>
      <div class="col-md-4">
        <button class="btn btn-primary" type="submit" [disabled]="!frmCaptcha?.valid">
          Submit
        </button>
      </div>
    </div>
  </form>
</swal>
